<template>
  <div class="cart-item flex flex-wrap border rounded-lg  mt-2 py-2 ">
    <div class="w-full md:w-2/3 py-2 ">
      <div class="flex flex-wrap items-center ">
        <div class=" relative ml-4 mr-8">
          <img
            class="media-item object-cover h-32 w-32"
            :src="course.course_image"
            alt=""
          />
        </div>
        <div class="text-xl tenant-main-color px-4 py-1 font-bold">
          {{ course.title }}
        </div>
      </div>
    </div>
    <div class="w-full md:w-1/3 ">
      <div
        class="flex md:flex-col justify-between items-center content-center h-full p-2 w-full"
      >
        <div class="text-tenant-color ml-4 text-xl font-semibold text-black ">
          {{ coursePrice }}
        </div>
        <div class="flex justify-between">
          <lms-outline-button
            :color="this.colorTheme"
            v-if="!courseInCart"
            @click="addCart"
            class="my-1 mr-2"
            >Add to Cart</lms-outline-button
          >
          <lms-button v-else @click="removeCart" class="mr-2"
            >Remove from Cart</lms-button
          >
          <lms-button
            @click="removeWishlist"
            transparent
            hasBorderColor="red"
            textColor="red"
            border
            >Remove</lms-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import SettingsMixin from "@/mixins/SettingsMixin";
export default {
  name: "wishlist-item",
  props: ["course", "courses"],
  mixins: [SettingsMixin],
  data() {
    return {
      videoFormats: ["mp4"],
    };
  },
  components: {
    LmsButton: () => import("@/components/general/button"),
    LmsOutlineButton: () => import("@/components/general/outline_button"),
    cartItem: () => import("@/components/learner/cartItem"),
  },
  methods: {
    ...mapActions(["learnerRemoveFromCart"]),
    removeCart() {
      this.$emit("removeCart", this.course.id);
    },
    removeWishlist() {
      this.$emit("removeWishList", this.course.id);
    },
    addCart() {
      this.$emit("addCart", this.course.id);
    },
  },
  computed: {
    coursePrice() {
      return typeof this.course.price !== "undefined"
        ? `${this.course.currency}${this.course.price}`
        : "FREE";
    },
    hasValidVideo() {
      let x = this.course.course_image.split(".");
      return this.videoFormats.includes(x[x.length - 1]);
    },
    courseInCart() {
      return Object.values(this.courses).includes(this.course.id);
    },
  },
};
</script>
<style lang="scss">
.media {
  height: 100px;
  width: 150px;

  .media-item {
    height: 100%;
    width: 100%;
  }
  .overlay {
    background-color: rgba(0 0 0 / 0.6);
  }
}
</style>
